import xss from 'xss';
import '../../css/pages/search.less';
import '../../css/pages/search_12.less';
console.log('courseData', courseData)
console.log('searchParams', searchParams)
// console.log('basesettingList', [[${basesettingList}]])
console.log(courseVO)
const languageList = ['汉语', '英语', '法语', '俄语', '藏语', '泰语', '日语', '韩语', '德语', '西班牙语', '越南语', '其他']
const educationalList = ['本科', '研究生']
const defaultFilterAndSort = ['课程状态', '学科专业', '课程专题', '开课学院', '所属学期', '培养层次', '语种', '课程平台', '课程类型']
const defaultSortKeys = [{
    label: '发布时间',
    value: 'publishTime'
}, {
    label: '参与人数',
    value: 'join',
    hideAsc: true
}, {
    label: '浏览量',
    value: 'hits',
    hideAsc: true
}]
window.search = new Vue({
    el: '#app',
    data() {
        return {
            courseStates: [
                { showValue: "即将开始", value: 1 },
                { showValue: "进行中", value: 2 },
                { showValue: "已结束", value: 3 }
            ],
            courseType: [],
            organization: [],
            collegeList: [],//学院列表
            collegeActive: null,//所属高校展开收起
            collegeKeyword: '',//学院搜索关键词
            semesterList: [],//学期列表
            hotTagList: [],//热门标签列表
            // professions: [],//专业
            classificationType: [],
            // subjectList: [],
            subjects: {
                class1: [],
                class2: [],
                tree: []
            },
            optionProps: {
                value: 'categoryCode',
                label: 'categoryName',
            },
            organizationOptions: [],
            organizationSelected: [],
            showMoreOptionActive: true,//更多选项状态开关
            form: {
                keyword: courseVO.keyword || null,
                subjectId: [],//学科专业
                college: null,//开课学院
                professionIds: [],//专业
                courseType: courseVO.courseType,//课程类型
                // platformType: courseVO.platformType,//课程平台
                platform: (courseVO.platform && courseVO.platform.length) ? courseVO.platform[0] : '',//课程平台
                classificationId: null,//课程分类
                semester_teaching_courses: null,//所属学期
                courseState: Number(courseVO.courseState),//课程状态
                field: courseVO.field || null,//排序依据
                isDesc: courseVO.isDesc || false,//排序方式
                tag: (courseVO.tag && courseVO.tag.length > 0) ? (courseVO.tag.length === 1 ? courseVO.tag[0] : courseVO.tag[1]) : '',//热门标签
                page: courseVO.page,
                size: courseVO.size,
                educational: courseVO.educational,
                languages: courseVO.languages,
                subjectCategories: courseVO.subjectCategories || ''
            },
            bannerPlateType,
            browserTabAbbreviation,
            headActive: bannerPlateType == '2' ? true : false,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            showMore: {
                major: {
                    hasMore: false,
                    active: true,
                    ready: false
                },
                college: {
                    hasMore: false,
                    active: true,
                    ready: false
                },
            },
            loading: false,
            sortParams: {
                field: '',
                isDesc: true,

            },
            showName: false,
            sortKeys: [],
            languageList,
            educationalList: bannerPlateType == '15' ? cultivationLevel : educationalList,
            platformTypes: [],
            filterAndSort: [],
            shTechBkSubjectList: [],
            selectSubject: ''
        }
    },
    directives: {
        keyword: {
            inserted: (el) => {
                // 聚焦元素
                if (!courseVO.keyword) return
                let text = el.innerHTML
                let index = text.indexOf(courseVO.keyword)
                let span = '<span style="color:var(--color-primary)">' + courseVO.keyword + '</span>'
                let textArr = text.split('')
                if (index > -1) {
                    textArr.splice(index, courseVO.keyword.length, span)
                }
                let res = textArr.join("")
                el.innerHTML = res
            }
        },
        show_more: {
            inserted: (el, binding, vnode) => {
                let that = vnode.context
                that.$nextTick(() => {
                    // console.log('自定义指令', el.clientHeight, this)
                    let maxRow = parseInt(el.getAttribute('data-row') || 1)
                    let rowHeight = 33
                    let maxHeight = maxRow * rowHeight
                    let currHeight = el.clientHeight
                    if (currHeight > (maxHeight + rowHeight / 2)) {//降低误差可能性，加个一半行高
                        console.log('大于')
                        // console.log(binding.value)
                        binding.value.hasMore = true
                        binding.value.active = false
                        el.style.height = maxHeight + 'px'
                        el.style.overflow = 'hidden'
                    } else {
                        el.style.height = 'auto'
                        el.style.overflow = 'auto'
                    }
                    // console.log(el.getAttribute('data-row'))
                    binding.value.ready = true

                })
            },
            update: (el, binding, vnode) => {
                let that = vnode.context
                that.$nextTick(() => {
                    let maxRow = parseInt(el.getAttribute('data-row') || 1)
                    let rowHeight = 33
                    let maxHeight = maxRow * rowHeight
                    if (!binding.value.active) {
                        el.style.height = maxHeight + 'px'
                        el.style.overflow = 'hidden'
                    } else {
                        el.style.height = 'auto'
                        el.style.overflow = 'auto'
                    }
                })
            }
        }
    },
    mounted() {
        const that = this
        this.getCategories()
        this.getSemesterList()
        this.initSortStatus()
        this.getHotTags()
        this.initCourseType()
        this.handleShTechBg()
        this.getShTechBkSubject()
        this.$on('ready', function () {
            //获取用户信息后执行
            this.initPlatform()
            let filterOption = this.sysModules.find(el => el.code == 'course_home_filter_and_sort')
            if (filterOption && filterOption.value != 'false') {
                if (filterOption.value == 'none') {
                    this.filterAndSort = []
                } else {
                    this.filterAndSort = filterOption.value.split(/,|，/)
                }
            } else {
                this.filterAndSort = defaultFilterAndSort
            }
            let sortOption = this.sysModules.find(el => el.code == 'course_home_sort_keys')
            if (sortOption && sortOption.value != 'false') {
                if (sortOption.value == 'none') {
                    this.sortKeys = []
                } else {
                    let arr = sortOption.value.split(/,|，/)
                    this.sortKeys = defaultSortKeys.filter((el) => arr.includes(el.label))
                }
            } else {
                this.sortKeys = defaultSortKeys
            }
            this.initShowMoreOptionState()
            if (window.target_customer == 'ppsuc') {
                this.educationalList = [...this.educationalList, '继续教育', '其他']
            }
        })
    },
    computed: {
        selectedCollege() {
            let selected = this.form.college
            let arr = this.collegeList.filter(el => {
                return selected.includes(el.code)
            })
            return arr
        },
        // selectedProfessionIds() {
        //     let selected = this.form.professionIds
        //     let arr = this.professions.filter(el => {
        //         return selected.includes(el.code)
        //     })
        //     return arr
        // },
        // platformTypes() {
        //     // 超星
        //     // 爱课堂
        //     // 雨课堂
        //     // 人卫慕课
        //     // 智慧树
        //     // 中国大学mooc
        //     let arr = []
        //     if (!this.sysModulesFormat.includes('show_third_party_courses')) return []
        //     _third_platform.map(el => {
        //         if (this.sysModulesFormat.includes(el.key)) {
        //             arr.push(el)
        //         }
        //     })
        //     return arr
        // },
        organizationFormat() {
            let { collegeList, sysModules } = this
            let excludeObj = sysModules.find(el => el.code == 'exclude_college_list')
            let excludeArr = (excludeObj ? excludeObj.value : '').split(/,|，/)
            // console.log('organizationFormat', collegeList, sysModules,excludeObj)
            return collegeList.filter(el => {
                // 对 `el.showValue` 和 `excludeArr` 进行 xss 过滤
                const safeShowValue = xss(el.showValue);
                const safeExcludeArr = excludeArr.map(item => xss(item));
                return !safeExcludeArr.includes(safeShowValue);
            });
        }
    },
    methods: {
        initPlatform() {
            let str = (this.sysModules.find(el => el.code == 'show_third_party_courses_list') || {}).value
            //show_third_party_courses_list_priority优先级更高，配置包含当前平台
            let _str = (this.sysModules.find(el => el.code == 'show_all_courses_list_priority') || {}).value
            let curr = (this.sysModules.find(el => el.code == 'course_platform_name') || {}).value
            try {
                let arr = JSON.parse(str)
                let _arr = JSON.parse(_str)
                // 中南大学手动修改排序 mooc 超星 知了 畅课
                if (bannerPlateType == '13') {
                    this.platformTypes = ['中国大学MOOC', '超星', '智学中南', '畅课教学平台']
                } else if (Array.isArray(arr)) {
                    this.platformTypes = [curr, ...arr]
                }
                if(_arr && Array.isArray(_arr)) {
                    this.platformTypes = _arr
                }
            } catch { }
        },
        initCourseType() {
            if (bannerPlateType == 8) {
                API.reqUserInfo().then(res => {
                    try {
                        res.data.moduleCode.extendMessage.map((item) => {
                            if (item.code == 'course_custom_order') {
                                let str = item.value
                                if (str.includes('，')) {
                                    str.replace('，', ',')
                                }
                                let arr = []
                                arr = str.split(',')
                                arr.map((item, index) => {
                                    this.courseType.push({
                                        label: item,
                                        value: index + ''
                                    })
                                })
                            }
                        })
                    } catch (error) {

                    }
                })
            } else {
                API.reqModuleConfig().then(res => {
                    if (res.errorCode == 'success') {
                        let modules = res.extendMessage
                        if (modules.includes('microcourse_kcgl')) {
                            this.courseType.push({ label: '微课', value: '0' })
                        }
                        if (modules.includes('mooc_kcgl')) {
                            this.courseType.push({ label: '公开课', value: '1' })
                        }
                        if (modules.includes('spoc_kcgl')) {
                            if (this.bannerPlateType == 9) {
                                this.courseType.unshift({ label: '班级课', value: '2' })
                            } else {
                                this.courseType.push({ label: '班级课', value: '2' })
                            }
                        }
                        if (modules.includes('training_kcgl')) {
                            this.courseType.push({ label: '培训课', value: '3' })
                        }
                        if (modules.includes('map_kcgl')) {
                            this.courseType.push({ label: '图谱课', value: '4' })
                        }
                    }
                })
            }
        },
        getSemesterList() {
            API.reqSemesterList().then(res => {
                if (res.status == 200) {
                    this.semesterList = res.data.map(el => {
                        return {
                            value: el.name,
                            showValue: el.showSemester || el.name
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        getCategories() {
            const { organization, classificationType, subjectEducation } = searchParams
            this.organization = organization
            this.classificationType = classificationType
            this.subjects.class1 = subjectEducation;
            this.subjects.tree = [{ categoryName: this.$t('全部学科'), categoryCode: '' }].concat(forTree(subjectEducation));
            let collegeList = []
            // let professions = []
            for (let i = 0; i < organization.length; i++) {
                collegeList.push({ value: organization[i].organizationCode, showValue: organization[i].organizationName })
                // for(let j = 0;j<organization[i].subOrgs.length;j++){
                //     professions.push(organization[i].subOrgs[j])
                // }
            }
            this.collegeList = collegeList
            // this.$nextTick(()=>this.initCollegesActive())
            // console.log('collegeList', collegeList)
            // this.professions = professions
            // 初始化已选值
            this.form.college = (courseVO.college && courseVO.college.length) ? courseVO.college[0] : ''
            this.form.professionIds = courseVO.professionIds || []
            this.form.subjectId = (courseVO.subjectId && courseVO.subjectId.length) ? courseVO.subjectId : ['']
            this.form.classificationId = courseVO.classificationId ? courseVO.classificationId[0] : ''
            this.form.semester_teaching_courses = courseVO.semester_teaching_courses || ""
            // console.log('form', this.form)

            if (this.form.subjectId.length) {
                this.subjects.class2 = (subjectEducation.find(el => el.categoryCode == this.form.subjectId[0]) || {}).children || []
                console.log('class2', this.subjects.class2, subjectEducation.find(el => el.categoryCode == this.form.subjectId[0]))
            }
        },
        getList() {
            this.loading = true
            // console.log(this.form)
            // return
            let href = '/learn/search?'
            let obj = { ...this.form, ...this.sortParams }
            // console.log(obj)
            for (let key in obj) {
                if (key == 'classificationId') {
                    href += `classificationId=${[this.form.classificationId]}&`
                } else if (key == 'college') {
                    href += `college=${[this.form.college]}&`
                } else if (obj[key] !== null) {
                    href += `${key}=${obj[key]}&`
                }
            }
            location.href = href
        },
        searchHandel() {
            this.form.page = 1
            this.getList()
        },
        clearHandel() {
            location.href = '/learn/search'
        },
        tagClose(key, val) {
            this.form[key].forEach((code, i) => {
                if (code == val) this.form[key].splice(i, 1)
            })
        },
        handleOptionChange(param) {
            // console.log('handleOptionChange',param);
            // if(!Object.keys(param).length) return
            Object.keys(param).map(key => {
                this.form[key] = param[key] || '';
            })
            this.searchHandel()
        },
        initShowMoreOptionState() {
            // console.log('initShowMoreOptionState',this.form)
            if (this.filterAndSort.length < 4 || bannerPlateType == '9') {
                this.showMoreOptionActive = true
                return //小于4条时默认展示
            }
            let { college, courseType, semester_teaching_courses, platform, educational, languages } = this.form
            // console.log('semester_teaching_courses', semester_teaching_courses)
            if (!college && courseType == -1 && !semester_teaching_courses && !platform && !educational && !languages) {
                this.showMoreOptionActive = false
            }
            if (this.sysModulesFormat.includes('course_home_default_expand')) {
                this.showMoreOptionActive = true
            }
        },
        initSortStatus() {
            this.sortParams = {
                field: courseVO.field,
                isDesc: courseVO.isDesc
            }
        },
        handleSortChange(field, hideAsc) {
            this.sortParams = {
                field,
                isDesc: hideAsc ? true : field == this.sortParams.field ? !this.sortParams.isDesc : true
            }
            this.form.page = 1;
            this.getList()
        },
        handleHotTagChange(tag) {
            this.form.tag = tag;
            this.getList();
        },
        //检索热门标签
        getHotTags() {
            const subject = this.form.subjectId;
            if (!subject.length || !subject[0]) return;
            let data = {
                firstSubject: subject[0],
                secondSubject: subject.length == 2 ? subject[1] : undefined
            }
            API.reqGetHotTag(data).then(res => {
                if (res.status == 200) {
                    this.hotTagList = res.data;
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleShTechBg() {
            const contentBg = document.querySelector('#shTech_bg .content_bg')
            const headerBg = document.querySelector('#shTech_bg .header_bg')
            if (contentBg && headerBg) {
                contentBg.style.height = window.innerHeight - headerBg.clientHeight + 'px'
                contentBg.style.width = window.innerWidth + 'px'
            }
        },
        getShTechBkSubject() {
            API.reqShTechBkSubject().then(res => {
                if (res.error_msg == 'Success') {
                    const arr = res.extend_message || []
                    this.shTechBkSubjectList = arr
                }
            }).catch(() => {
                console.error('获取类别失败')
            })
        }
    }
})
